import { NgModule } from '@angular/core';

import { ApKeyValueComponent } from './key-value.component';
import { ApKeyComponent } from './key.component';
import { ApValueComponent } from './value.component';

@NgModule({
    exports: [ApKeyValueComponent, ApKeyComponent, ApValueComponent],
    imports: [ApKeyValueComponent, ApKeyComponent, ApValueComponent]
})
export class ApKeyValueModule {}
